import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"
import { z } from "zod"

import { EndUsersTable } from "@/features/end-users/components/EndUsersTable"

/**
 * ADR #020 revize (2026-04-21): /users artık ApplicationUser (son kullanıcı)
 * listesini gösteriyor. Eskiden Site/Customer listesi vardı — DB'de
 * "Kullanıcı" = mobil uygulama login'i (ApplicationUser); Site ise ona bağlı
 * tesis. Backend: GET /api/SuperAdmin/users (siteCount/deviceCount enriched).
 * 2026-04-24 — `?id=<guid>` deep-link.
 */
const searchSchema = z.object({ id: z.string().optional() })

export const Route = createFileRoute("/_authed/users")({
  // Org-scoped kullanıcıya AÇIK (2026-08-04). `SuperAdmin/users` okuma uçları AdminOnly'den
  // çıkıp ResolveOrgScope'a geçti; liste caller'ın alt ağacına filtrelenir. Partner/bayi
  // ATAMASI AdminOnly kaldığı için düzenle aksiyonu tabloda gizlenir.
  component: UsersPage,
  validateSearch: (raw) => searchSchema.parse(raw),
})

function UsersPage() {
  const { t } = useTranslation("users")
  const { id } = Route.useSearch()
  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="border-b border-ok-border px-6 py-4">
        <h1 className="text-lg font-semibold tracking-tight">{t("title")}</h1>
        <p className="text-xs text-ok-foreground-muted">{t("subtitle")}</p>
      </div>
      <EndUsersTable initialSelectedId={id ?? null} />
    </div>
  )
}
